<template>
    <div data-test-view="learning-admin-path-dashboard-user-remove">
        <p>
            {{
                $t("learning.admin.path.dashboard.removeUser.explanation", {
                    name: user.firstname + " " + user.lastname,
                    path: path.name,
                })
            }}
        </p>

        <hr />

        <div class="footer">
            <button
                class="btn btn-raised"
                data-test-id="learning-admin-path-dashboard-user-remove-cancel"
                @click="cancel"
            >
                {{ $t("learning.admin.path.dashboard.removeUser.cancel") }}
            </button>
            <button
                class="btn btn-danger btn-raised"
                data-test-id="learning-admin-path-dashboard-user-remove-confirm"
                @click="removeUser"
            >
                {{ $t("learning.admin.path.dashboard.removeUser.confirm") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        pathId: {
            type: String,
            required: true,
        },
        userId: {
            type: String,
            required: true,
        },
        progressId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters({
            getUser: "users/details/details",
            getPath: "learning/path/details",
        }),
        user() {
            return this.getUser(this.userId);
        },
        path() {
            return this.getPath(this.pathId);
        },
    },
    methods: {
        async removeUser() {
            await this.$store.dispatch({
                type: "learning/progress/delete",
                payload: { id: this.progressId },
            });

            this.$router.push(`/learning/admin/path/${this.pathId}/dashboard`);
        },
        cancel() {
            this.$router.push(`/learning/admin/path/${this.pathId}/dashboard`);
        },
    },
};
</script>

<style scoped>
p {
    white-space: pre-wrap;
}
</style>
